export default "/Frontend/dist/pdf-hover.4f613b4ca3a529948668e4a3a751b19a.svg";